<template>
    <div :class="$common.getStyleName('server-componesnts')">
        <div :class="$common.getStyleName('server-1')" v-if="$modulList.server === 1"><Server1></Server1></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Server1 from './Server1'

    export default {
        name : 'serverBox',
        components: {
            Server1
        },
        data() {
            return {};
        },
        computed: {
            ...mapState(['$modulList', '$common']),
        },

    };
</script>

<style type="scss">

</style>



// WEBPACK FOOTER //
// website/components/servers/Index.vue